import React from 'react';
import Header from './Header';
import SEO from './SEO';

const TermsOfService = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO 
        title="Terms of Service - PocketHints"
        description="Terms of Service for PocketHints Helper."
        url={(typeof window !== 'undefined' ? window.location.origin : '') + '/terms-of-service'}
      />
      
      <Header 
        date={new Date().toISOString()} 
        title="Terms of Service" 
        heroTitle="Terms of Service"
        introText="The rules and guidelines for using the PocketHints website and services."
      />

      <main className="flex-grow max-w-4xl mx-auto px-4 w-full pb-20">
        <h1 className="text-3xl font-bold mb-6 text-brand-black">Terms of Service</h1>
        
        <div className="prose max-w-none text-gray-700 space-y-4">
        <p className="text-sm text-gray-500">Last updated: {new Date().toLocaleDateString()}</p>

        <h2 className="text-xl font-bold mt-6 mb-2">1. Acceptance of Terms</h2>
        <p>
          By accessing or using PocketHints Helper, you agree to be bound by these Terms of Service. 
          If you do not agree to these terms, please do not use our service.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-2">2. Use License</h2>
        <p>
          Permission is granted to temporarily download one copy of the materials (information or software) on PocketHints Helper for personal, 
          non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>modify or copy the materials;</li>
          <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
          <li>attempt to decompile or reverse engineer any software contained on PocketHints Helper;</li>
          <li>remove any copyright or other proprietary notations from the materials; or</li>
          <li>transfer the materials to another person or "mirror" the materials on any other server.</li>
        </ul>

        <h2 className="text-xl font-bold mt-6 mb-2">3. Disclaimer</h2>
        <p>
          The materials on PocketHints Helper are provided on an 'as is' basis. PocketHints Helper makes no warranties, expressed or implied, 
          and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, 
          fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-2">4. Limitations</h2>
        <p>
          In no event shall PocketHints Helper or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, 
          or due to business interruption) arising out of the use or inability to use the materials on PocketHints Helper, 
          even if PocketHints Helper or a PocketHints Helper authorized representative has been notified orally or in writing of the possibility of such damage.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-2">5. Accuracy of Materials</h2>
        <p>
          The materials appearing on PocketHints Helper could include technical, typographical, or photographic errors. 
          PocketHints Helper does not warrant that any of the materials on its website are accurate, complete or current. 
          PocketHints Helper may make changes to the materials contained on its website at any time without notice. 
          However PocketHints Helper does not make any commitment to update the materials.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-2">6. Links</h2>
        <p>
          PocketHints Helper has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. 
          The inclusion of any link does not imply endorsement by PocketHints Helper of the site. Use of any such linked website is at the user's own risk.
        </p>

        <h2 className="text-xl font-bold mt-6 mb-2">7. Modifications</h2>
        <p>
          PocketHints Helper may revise these terms of service for its website at any time without notice. 
          By using this website you are agreeing to be bound by the then current version of these terms of service.
        </p>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;

